"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = react_1.css `
  html,
  body {
    margin: 0px;
    padding: 0px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html {
    overflow-x: overlay;
    overflow-y: overlay;

    font-size: 62.5%;
  }
  body {
    font-size: 1.4rem;
    line-height: 1.3;
  }

  #__next {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  a {
    cursor: pointer;

    transition: all 0.2s;
  }

  button,
  input,
  select {
    background: none;
    border: none;
    outline: none;
  }

  button {
    cursor: pointer;
  }

  button[disabled] {
    cursor: default;
  }

  * {
    box-sizing: border-box;
  }
`;
